<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({ disabled: { type: Boolean, default: false } });
const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const updateValue = () => {
  if (props.disabled) return;
  modelValue.value = !modelValue.value;
  emit('change', !modelValue.value);
};
</script>

<template>
  <button
    type="button"
    class="switch-target group relative !inline-flex h-11 min-h-11 w-11 min-w-11 flex-shrink-0 items-center justify-center rounded-full !bg-transparent !p-0 !text-n-slate-12 select-none focus:outline-none disabled:cursor-not-allowed"
    :disabled="disabled"
    role="switch"
    :aria-checked="modelValue"
    @click="updateValue"
  >
    <span class="sr-only">{{ t('SWITCH.TOGGLE') }}</span>
    <span
      data-switch-track
      aria-hidden="true"
      class="switch-track relative block h-5 w-9 shrink-0 rounded-full transition-colors duration-200 ease-in-out"
      :class="modelValue ? 'bg-n-brand' : 'bg-n-slate-6'"
    >
      <span
        class="absolute top-1/2 ltr:left-0.5 rtl:right-0.5 -translate-y-1/2 transition-transform duration-[350ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]"
        :class="
          modelValue
            ? 'ltr:translate-x-4 rtl:-translate-x-4 group-active:ltr:translate-x-[12px] rtl:group-active:-translate-x-[12px]'
            : 'ltr:translate-x-0 rtl:translate-x-0'
        "
      >
        <span
          class="block h-4 w-4 rounded-full bg-white shadow-md transition-[width] duration-[180ms] ease-in-out group-active:w-[20px]"
        />
      </span>
    </span>
  </button>
</template>

<style scoped>
.switch-target:focus-visible .switch-track {
  outline: 2px solid currentColor;
  outline-offset: 3px;
}
</style>
